import React from 'react';
import PropTypes from 'prop-types';

const TwoColumnRedAndBlackTile = ({ columnData }) => {
  return (
    <section>
      <div className="prerequisites-main">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6">
              <div className="prerequisites-single">
                <h3 className="small-heading white-txt">
                  {columnData[0].title}
                </h3>
                <p>{columnData[0].description}</p>
              </div>
            </div>
            <div className="col-lg-5 offset-lg-2 col-md-6">
              <div className="prerequisites-single mob-prerequisites">
                <h3 className="small-heading white-txt">
                  {columnData[1].title}
                </h3>
                <p>{columnData[1].description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

TwoColumnRedAndBlackTile.propTypes = {
  columnData: PropTypes.array,
};

export default TwoColumnRedAndBlackTile;
